import React, { useContext, useEffect } from 'react';

import styled from '@emotion/styled';

import { configSetting } from '../../../config';
import { ModalContext } from '../../../context/ModalContext';
import useGetPaymentLink from '../../../hooks/trackPackage/useGetPaymentLink';
import useTrackPackages from '../../../hooks/trackPackage/useSetTrackPackage';
import { paymentLinkActions } from '../../../redux/slices/paymentLinkSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import { FormSubmitButton } from '../../Button/FormSubmitButton';
import PaystackIframe from '../../Card/PaystackIframe';
import CardIcon from '../../Icons/CardIcon';
import ModalContainer from '../ModalContainer';

interface ITrackPackagePaymentModal {}

const TrackPackagePaymentModal: React.FC<ITrackPackagePaymentModal> = () => {
  const dispatch = useAppDisPatch();
  const modalContext = useContext(ModalContext);
  const { trackPackages } = useTrackPackages();
  const { trackPackage } = useAppSelector((state) => state.trackPackage);
  const { getPaymentLink, paymentLinkloading, paymewntLink } =
    useGetPaymentLink();

  useEffect(() => {
    const handlePaymentMessage = (event: any) => {
      if (event.data === 'paymentCompleted') {
        trackPackages(trackPackage?.packageId ?? '');
        dispatch(paymentLinkActions.setPaymentLink({ paymentLink: undefined }));
        modalContext?.setShowModal(false);
      }
    };
    window.addEventListener('message', handlePaymentMessage);
    return () => {
      window.removeEventListener('message', handlePaymentMessage);
    };
    // eslint-disable-next-line
  }, [dispatch, trackPackages, trackPackage?.packageId, modalContext]);

  const onClickProceed = async (e: any) => {
    await getPaymentLink({
      callbackUrl: `${configSetting.callbackUrlBase}payment-successful`,
      productId: trackPackage?.packageId,
    });
  };

  if (paymewntLink) {
    return <PaystackIframe paymentLink={paymewntLink ?? ''} />;
  }

  return (
    <>
      <ModalContainer
        label='Pay with Card'
        description='Make payments effortlessly using any nationally accepted debit card'
      >
        <HeaderSection>
          <CardIconWrapper>
            <CardIcon />
            Card Payment
          </CardIconWrapper>
        </HeaderSection>
        <FormSubmitButton onClick={onClickProceed} loading={paymentLinkloading}>
          Proceed
        </FormSubmitButton>
      </ModalContainer>
    </>
  );
};

export default TrackPackagePaymentModal;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* border: 2px solid red; */
`;

const CardIconWrapper = styled.div`
  padding: 14px;
  font-weight: 600;
  color: black;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  line-height: 22px;
  /* cursor: pointer; */
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: white;

  border: 1px solid ${({ theme }) => theme.palette.redFontColor};

  & > svg {
    color: ${({ theme }) => theme.palette.redFontColor};
  }

  &.red {
    background-color: ${({ theme }) => theme.palette.redFontColor};
    color: white;
    font-weight: 600;
    border-radius: 8px;
    border-color: ${({ theme }) => theme.palette.redFontColor};

    &:hover {
      border-color: white;
    }
  }

  &.margin-top {
    margin-top: 20px;
  }
`;
